import { z } from 'zod';

import {
    createDeleteSchema,
    createUpdateSchemaFromAdd,
    requiredNumber,
    requiredString,
    requiredUuid,
} from './fields';
import { SYNC_UPDATE_VALIDATION_SCHEMA } from './common';

export const createDeviceCalendarEventsAddSchema = () =>
    z.object({
        id: requiredUuid(),
        created_at: requiredNumber(),
        updated_at: requiredNumber(),
        device_id: requiredString(),
        calendar_event_id: requiredString(),
        event_id: requiredUuid(),
        user_id: requiredUuid(),
    });

export const createDeviceCalendarEventsUpdateSchema = () =>
    createUpdateSchemaFromAdd(
        createDeviceCalendarEventsAddSchema(),
        SYNC_UPDATE_VALIDATION_SCHEMA.device_calendar_events,
    );

export const createDeviceCalendarEventsDeleteSchema = () =>
    createDeleteSchema();

export const createDeviceCalendarEventsSchemas = () => ({
    add: createDeviceCalendarEventsAddSchema(),
    update: createDeviceCalendarEventsUpdateSchema(),
    delete: createDeviceCalendarEventsDeleteSchema(),
});
